import { createPostApi } from "@api/util/createPostApi";

import type { IApiResponse } from "@api";

import type { IPathBaseParam } from "./path";
import type { IScrapUnitsDto } from "./types";

const postApis = createPostApi<
  IApiResponse<unknown>,
  IPathBaseParam,
  IScrapUnitsDto
>("stores.warehouses.scrapUnits");

export const scrapUnits = {
  ...postApis,
};
